<template>
  <div class="w-full">
    <ContentSectionLoader v-if="!loaded" />
    <Transition name="fade">
      <div v-if="loaded">
        <section
          v-if="communications.length"
          class="flex flex-wrap items-stretch"
        >
          <div
            v-for="communication in communications"
            :key="`${communication.attributes._type}-${communication.uuid}`"
            class="flex w-full"
          >
            <BlogEntryCard
              v-if="communication.attributes._type === 'BlogEntry'"
              :blog="communication"
              @openArchiveModal="(blogEntry) => $store.commit('communicationOpenArchiveBlogEntryModal', blogEntry)"
              @openDeleteModal="(blogEntry) => $store.commit('communicationOpenDeleteBlogEntryModal', blogEntry)"
            />
            <EmailCard
              v-if="communication.attributes._type === 'Email'"
              :email="communication"
              @openArchiveModal="(email) => $store.commit('communicationOpenArchiveEmailModal', email)"
              @openDeleteModal="(email) => $store.commit('communicationOpenDeleteEmailModal', email)"
            />
            <SMSCard
              v-if="communication.attributes._type === 'SMS'"
              :sms="communication"
              @openArchiveModal="(sms) => $store.commit('communicationOpenArchiveSMSModal', sms)"
              @openDeleteModal="(sms) => $store.commit('communicationOpenDeleteSMSModal', sms)"
            />
          </div>
          <div class="flex-1 mt-4">
            <Pagination
              v-show="hasMultiplePages"
              :pagination="pagination"
            />
          </div>
        </section>
        <CommunicationsNoResults
          v-else
          :status="status"
        />
      </div>
    </Transition>
    <ArchiveBlogEntryModal @archived="fetch" />
    <RestoreArchivedCommunicationModal @restored="fetch" />
    <DeleteBlogEntryModal @destroyed="fetch" />
    <ArchiveSMSModal @archived="fetch" />
    <DeleteSMSModal @destroyed="fetch" />
    <ArchiveEmailModal @archived="fetch" />
    <DeleteEmailModal @destroyed="fetch" />
    <SendCommToOrganizationsModal />
  </div>
</template>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'
import DeleteSMSModal from './_modals/DeleteSMSModal'
import ArchiveSMSModal from './_modals/ArchiveSMSModal'
import DeleteEmailModal from './_modals/DeleteEmailModal'
import ArchiveEmailModal from './_modals/ArchiveEmailModal'
import DeleteBlogEntryModal from './_modals/DeleteBlogEntryModal'
import ArchiveBlogEntryModal from './_modals/ArchiveBlogEntryModal'
import SendCommToOrganizationsModal from './_modals/SendCommToOrganizationsModal'
import RestoreArchivedCommunicationModal from './_modals/RestoreArchivedCommunicationModal'
import CommunicationsNoResults from 'Communication/Resources/assets/js/components/CommunicationsNoResults'

export default {
  name: 'CommunicationsList',
  components: {
    DeleteSMSModal,
    DeleteEmailModal,
    ArchiveSMSModal,
    ArchiveEmailModal,
    DeleteBlogEntryModal,
    ArchiveBlogEntryModal,
    CommunicationsNoResults,
    SendCommToOrganizationsModal,
    RestoreArchivedCommunicationModal,
  },
  props: {
    page: {
      type: [String, Number],
      required: false,
      default: 1,
    },
    categorySlug: {
      type: String,
      required: false,
      default: '',
    },
    status: {
      type: String,
      required: true,
    },
    types: {
      type: Array,
      required: false,
      default: () => [],
    },
    sortDirection: {
      type: String,
      required: false,
      default: 'desc',
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapState({
      communications: state => state.communication.communications.data,
      pagination: state => state.communication.communications.meta.pagination,
      pageCount: state => state.communication.communications.meta.pagination.total_pages,
      hasMultiplePages: state => state.communication.communications.meta.pagination.total_pages > 1,
    }),
  },
  watch: {
    types() {
      this.fetch()
    },
    sortDirection() {
      this.fetch()
    },
    loaded() {
      this.$emit('loaded', this.loaded)
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    ...mapActions([
      'communicationGetCommunications',
    ]),
    fetch() {
      this.loaded = false

      this.communicationGetCommunications({
        params: {
          types: this.types.join(','),
          include: 'author,categories',
          category: this.categorySlug,
          status: this.status,
          page: this.page,
          sort_direction: this.sortDirection,
        },
      })
        .then(() => {
          this.loaded = true
        })
    },
  },
}
</script>
